import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { WhitelabelEndpoints } from '../endpoints/core.endpoints';
import {
  WhitelabelConfig,
  WhitelabelListParams,
  WhitelabelListResponse,
} from './whitelabel.model';

@Injectable({
  providedIn: 'root',
})
export class WhitelabelService {
  private readonly http = inject(HttpClient);

  whitelabelConfig = signal<WhitelabelConfig | null>(null);

  getAll(params: WhitelabelListParams): Observable<WhitelabelListResponse> {
    let httpParams = new HttpParams()
      .set('includeDisabled', false)
      .set('includeCanceled', false)
      .append('sort', 'id:asc')
      .append('sort', 'name:desc')
      .set('page', params.page)
      .set('perPage', params.perPage);

    if (params.search) {
      httpParams = httpParams.set('search', params.search);
    }

    return this.http.get<WhitelabelListResponse>(
      `${environment.baseUrl}/${WhitelabelEndpoints.list}`,
      { params: httpParams },
    );
  }

  getPublicConfigurations(
    origin: string,
    slug?: string,
  ): Observable<WhitelabelConfig> {
    const params: Record<string, string> = { origin };
    if (slug) {
      params['slug'] = slug;
    }

    return this.http
      .get<WhitelabelConfig>(
        `${environment.baseUrl}/${WhitelabelEndpoints.publicConfig}`,
        { params },
      )
      .pipe(
        tap((config) => {
          this.whitelabelConfig.set(config);
        }),
      );
  }
}
